export const AUTH_CONFIG = {
  domain: 'granite-world.auth0.com',
  clientId: 'ehwg5SKpXW4onW1I3Py2zsIX2V3ygwVc',
  callbackUrl: `${window.location.protocol}//${window.location.host}/callback`,
  scope: 'openid profile email read:timesheet create:timesheet approve:timesheet delete:timesheet',
  apiUrl: 'graniteworldutah.com/api',
  responseType: 'token id_token'
}
